import { Chip, Tooltip } from '@mui/material';
import {
  TrendingUp,
  TrendingDown,
  TrendingFlat,
} from '@mui/icons-material';
import { MomentumState, MomentumBadgeProps } from '../../types/momentum.types';

const MOMENTUM_CONFIG: Record<MomentumState, {
  label: string;
  color: 'success' | 'info' | 'error';
  icon: React.ReactElement;
  description: string;
}> = {
  IMPROVING: {
    label: 'Improving',
    color: 'success',
    icon: <TrendingUp />,
    description: 'Performance is improving across key metrics',
  },
  STABLE: {
    label: 'Stable',
    color: 'info',
    icon: <TrendingFlat />,
    description: 'Performance is stable with minimal changes',
  },
  DECLINING: {
    label: 'Declining',
    color: 'error',
    icon: <TrendingDown />,
    description: 'Performance is declining - action recommended',
  },
};

const CONFIDENCE_LABELS: Record<'HIGH' | 'MEDIUM' | 'LOW', string> = {
  HIGH: 'High confidence',
  MEDIUM: 'Medium confidence',
  LOW: 'Low confidence',
};

export default function MomentumBadge({
  state,
  confidence,
  size = 'medium',
  showConfidence = false,
}: MomentumBadgeProps) {
  const config = MOMENTUM_CONFIG[state];

  const label = showConfidence && confidence
    ? `${config.label} (${CONFIDENCE_LABELS[confidence]})`
    : config.label;

  return (
    <Tooltip title={config.description} arrow>
      <Chip
        label={label}
        color={config.color}
        size={size}
        icon={config.icon as any}
        sx={{ fontWeight: 600, cursor: 'help' }}
      />
    </Tooltip>
  );
}
